<style lang="scss" scoped>
@use 'sass:color';
@use '../../palette.scss' as *;

$input-box-width: 300px;

.user-edit-page {
    padding: 10px;
    display: flex;
    flex-flow: row wrap;

    .user-details-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        color: $theme-dark-grey;
    }

    .spinner-block {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-around;

        .spinner-container {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 60px;
            width: 60px;

            .blocks {
                position: relative;
                width: 100%;
                height: 100%;

                .block {
                    position: absolute;
                    width: 35%;
                    height: 35%;
                    border-radius: 3px;
                    animation-duration: 0.5s;
                    animation-iteration-count: infinite;
                    animation-timing-function: linear;

                    &.one {
                        left: 10%;
                        top: 10%;
                        animation-name: blockone;
                        background-color: $theme-dark-blue;
                    }

                    &.two {
                        left: 55%;
                        top: 10%;
                        animation-name: blocktwo;
                        background-color: $theme-blue;
                    }

                    &.three {
                        left: 55%;
                        top: 55%;
                        animation-name: blockthree;
                        background-color: $theme-light-blue;
                    }

                    @keyframes blockone {
                        50% {
                            left: 10%;
                            top: 10%;
                            background-color: $theme-dark-blue;
                        }

                        100% {
                            left: 55%;
                            top: 10%;
                            background-color: $theme-blue;
                        }
                    }

                    @keyframes blocktwo {
                        25% {
                            left: 55%;
                            top: 10%;
                            background-color: $theme-blue;
                        }

                        50% {
                            left: 55%;
                            top: 55%;
                            background-color: $theme-light-blue;
                        }

                        100% {
                            left: 55%;
                            top: 55%;
                            background-color: $theme-light-blue;
                        }
                    }

                    @keyframes blockthree {
                        0% {
                            left: 55%;
                            top: 55%;
                            background-color: $theme-light-blue;
                        }

                        50% {
                            left: 10%;
                            top: 55%;
                            background-color: color.scale(
                                $theme-blue,
                                $lightness: 20%
                            );
                        }

                        75% {
                            left: 10%;
                            top: 55%;
                            background-color: color.scale(
                                $theme-blue,
                                $lightness: 20%
                            );
                        }

                        100% {
                            left: 10%;
                            top: 10%;
                            background-color: $theme-dark-blue;
                        }
                    }
                }
            }

            .fa,
            .fas {
                font-size: 2em;

                &.fa-check {
                    color: $theme-green;
                }

                &.fa-location-arrow {
                    color: $theme-grey;
                }
            }
        }

        .dots {
            flex-grow: 1;
            border-bottom: 2px dotted $theme-light-grey;
            margin: 0 15px;
        }
    }

    .error-text {
        padding: 10px 20px;
        font-size: 0.8em;
        color: $theme-red;
    }

    .prop-block {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: baseline;
        padding: 5px 8px 15px;

        &.center {
            align-items: center;
            justify-content: center;
        }

        &:not(.event) {
            margin-bottom: 8px;
        }

        &.event {
            padding: 5px 10px;

            &.subhead {
                margin: 0 15px;

                &.borderline {
                    border-bottom: 1px dashed $theme-light-grey;
                }
            }
        }

        &.top-margin {
            margin-top: 15px;
        }

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 25px;
            margin-left: 8px;

            &.circle .button-content {
                padding: 3px;
            }

            .fa-plus {
                margin: 1px 0;
            }
        }

        .twofaname {
            width: 40px;
            font-weight: bold;
            text-align: right;
        }

        .not-allowed::after {
            content: '⊘';
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: right;
            background: transparent;
            font-size: 2.5em;
            margin-top: -5px;
            margin-right: 2px;
            color: red;
        }

        .prop {
            width: 100%;
            position: relative;

            &.with-delete {
                &:hover,
                &.swiped {
                    .delete-btn-ctn,
                    .test-btn-ctn {
                        opacity: 1;
                    }
                }

                .delete-btn-ctn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    left: calc(100% - 32px);
                    top: 4px;
                    opacity: 0;
                    transition: opacity 0.25s;

                    button {
                        margin: 0 5px 10px 0;
                    }

                    button {
                        background-color: transparent;
                        color: $theme-red;
                        font-size: 1.7em;
                        border: none;
                        outline: none;

                        i {
                            border-radius: 50%;

                            &:hover {
                                background-color: color.scale(
                                    $theme-red,
                                    $alpha: -85%
                                );
                                color: color.scale($theme-red, $lightness: -5%);
                            }

                            &:active {
                                transform: scale(0.97);
                            }
                        }
                    }
                }

                .test-btn-ctn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    left: calc(100% - 42px);
                    top: 35px;
                    opacity: 0;
                    transition: opacity 0.25s;
                }
            }

            &:not(.name) {
                display: flex;
                justify-content: center;
            }

            &.password {
                display: flex;
                justify-content: center;
            }

            &.right {
                justify-content: flex-end;
            }

            &.event-header {
                display: flex;
                align-items: center;
            }

            .input-box {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-grow: 1;
                position: relative;
                margin-right: 30px;

                &.country {
                    width: 60px;
                }

                &.dropdown {
                    width: $input-box-width;
                    flex-grow: 0;
                    justify-content: center;
                }

                &.with-border {
                    border-bottom: 2px solid $theme-light-grey;
                    padding-bottom: 12px;
                    margin-right: 35px;
                }

                .input-box-container {
                    width: $input-box-width;
                    max-width: 90%;
                    position: relative;
                }

                .dropdown-container {
                    min-width: 200px;
                }

                .input-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .asterisk {
                    margin-right: 6px;
                    color: transparent; /* hidden by default */
                    font-weight: bold;
                }

                .has-error .asterisk {
                    color: red;
                }

                .has-error :deep(input) {
                    border-color: red;
                    color: red;
                }
            }

            .twofapadding {
                margin-left: 40px;
            }

            .current-label {
                position: absolute;
                display: flex;
                top: 100%;
                right: 0;
                background-color: color.scale(
                    $theme-light-grey,
                    $lightness: -5%
                );
                padding: 3px 4px 3px 2px;
                color: white;
                transform: scaleY(0);
                transition: transform 0.5s;
                font-size: 0.8em;
                transform-origin: top;
                white-space: nowrap;

                &:before {
                    content: '';
                    height: 100%;
                    position: absolute;
                    right: 100%;
                    top: 0;
                    background-image: url('../../../assets/CurrentValueSlash.svg');
                    background-size: 100%;
                    width: 8px;
                }

                &.discrepancy {
                    transform: scaleY(1);
                }

                .revert-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 19px;
                    height: 19px;
                    margin: 0;
                    padding: 2px;
                    margin-left: 3px;
                    transition: transform 0.25s;
                    color: color.scale(white, $lightness: -10%);
                    font-size: 0.9em;
                    padding: 1px 0 0 0;
                    background-color: transparent;
                    border: none;

                    &:focus {
                        outline: none;
                    }

                    &:active {
                        font-size: 0.8em;
                    }

                    &:hover {
                        transform: rotate(-20deg);
                    }
                }

                &:hover {
                    cursor: default;

                    .revert-icon {
                        color: white;

                        &:hover {
                            color: $theme-light-blue;
                            cursor: pointer;
                        }
                    }
                }
            }

            &.name {
                font-weight: bold;
            }

            .visible-button {
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 3px;
                border: 1px solid $theme-light-blue;
                color: $theme-light-grey;
                background-color: white;
                padding: 5px;
                margin-left: 8px;

                &:hover {
                    background-color: color.scale(
                        $theme-light-blue,
                        $alpha: -85%
                    );
                    border: 1px solid
                        color.scale($theme-light-blue, $lightness: -5%);
                    color: color.scale($theme-light-grey, $lightness: -5%);
                    cursor: pointer;
                }

                &:active {
                    transform: scale(0.97);
                }

                .fa-times {
                    margin: 0 2px;
                }

                .fa-plus {
                    margin: 0 1px;
                }

                &.visible {
                    color: $theme-light-blue;

                    &:hover {
                        color: color.scale($theme-light-blue, $lightness: -5%);
                    }
                }
            }
        }
    }

    .button-row {
        margin: 8px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        & > .button {
            margin-left: 10px;
        }
    }
}

@media (min-width: 600px) {
    .user-edit-page {
        .user-details-container {
            .prop-block {
                flex-flow: row nowrap;

                &.center {
                    justify-content: center;
                    align-items: center;
                }

                .prop {
                    width: 48%;

                    &:not(.name) {
                        text-align: left;
                    }

                    &.toggle {
                        padding-right: 15px;
                    }

                    &.password {
                        padding-right: 15px;
                    }

                    .delete-btn-ctn,
                    .test-btn-ctn {
                        opacity: 0;
                    }

                    .test-btn-ctn {
                        left: initial;
                        top: 2px;
                        right: calc(100% + 32px);
                    }
                }
            }

            .setlistgap {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            .settopgap {
                margin-top: 16px;
            }
        }
    }
}

.modal-body {
    .input-box {
        max-width: 230px;

        &.country {
            max-width: 75px;
            margin-right: 50px;
        }
    }

    .country-plus {
        font-weight: bold;
        padding-right: 8px;
    }
}

.pad-right {
    width: auto;
    margin-right: 8px;
}

.prop {
    &.input {
        flex-grow: 1;
        padding: 0 15px;
    }
}

.user-edit-loading {
    font-weight: bold;
}

.recovery-codes-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.recovery-code {
    font-family: monospace;
    background: #f5f6f8;
    border: 1px solid #e3e5e8;
    border-radius: 4px;
    padding: 8px;
    text-align: center;
}

::v-deep(.modal-footer button) {
    margin-right: 10px;
}

::v-deep(.modal-footer button:last-child) {
    margin-right: 0;
}
</style>

<template>
    <div class="user-edit-page">
        <SaveWidget
            :state="saveState"
            :customFailText="saveFailText"
            @save="saveUserSettings"
            @retry="saveUserSettings"
            @cancel="cancelUserSettings"
            @hide="saveSucceeded = false"
        />

        <!-- General settings card -->
        <Card :maxWidth="'700px'" fullWidth color="blue">
            <template #header>{{ $t('generalSettings') }}</template>
            <template #body>
                <div class="user-details-container" v-if="user && initialUser">
                    <!-- Name -->
                    <div class="prop-block">
                        <div class="prop name">{{ $t('name') }}</div>
                        <div class="prop">
                            <div class="input-box">
                                <div :class="{ 'has-error': !user.name }">
                                    <InputBox
                                        type="text"
                                        center
                                        v-model="user.name"
                                        :placeholder="`**${$t('required')}**`"
                                    >
                                        <div
                                            class="current-label"
                                            :class="{
                                                discrepancy:
                                                    initialUser.name !==
                                                    user.name,
                                            }"
                                        >
                                            {{ $t('currently') }}:
                                            {{ initialUser.name }}
                                            <button
                                                class="revert-icon"
                                                @click="
                                                    user.name = initialUser.name
                                                "
                                                v-tooltip.right="
                                                    $t('revertValue')
                                                "
                                                tabindex="-1"
                                            >
                                                <i class="fa fa-undo-alt"></i>
                                            </button>
                                        </div>
                                    </InputBox>
                                </div>
                                <div class="button-box"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Description -->
                    <div class="prop-block">
                        <div class="prop name">{{ $t('description') }}</div>
                        <div class="prop">
                            <div class="input-box">
                                <InputBox
                                    type="text"
                                    center
                                    v-model="user.description"
                                    :placeholder="`**${$t('optional')}**`"
                                >
                                    <div
                                        class="current-label"
                                        :class="{
                                            discrepancy:
                                                initialUser.description !==
                                                user.description,
                                        }"
                                    >
                                        {{ $t('currently') }}:
                                        {{ initialUser.description }}
                                        <button
                                            class="revert-icon"
                                            @click="
                                                user.description =
                                                    initialUser.description
                                            "
                                            v-tooltip.right="$t('revertValue')"
                                            tabindex="-1"
                                        >
                                            <i class="fa fa-undo-alt"></i>
                                        </button>
                                    </div>
                                </InputBox>
                                <div class="button-box"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="prop-block">
                        <div class="prop name">{{ $t('primaryEmail') }}</div>
                        <div class="prop input">
                            <div class="input-box">
                                <div
                                    class="input-wrapper"
                                    :class="{
                                        'has-error': !isValidUserEmailEntry,
                                    }"
                                >
                                    <InputBox
                                        type="text"
                                        center
                                        v-model="user.email"
                                        placeholder="user@example.com"
                                    >
                                        <div
                                            class="current-label"
                                            :class="{
                                                discrepancy:
                                                    initialUser.email !==
                                                    user.email,
                                            }"
                                        >
                                            {{ $t('currently') }}:
                                            {{ initialUser.email }}
                                            <button
                                                class="revert-icon"
                                                @click="
                                                    user.email =
                                                        initialUser.email
                                                "
                                                v-tooltip.right="
                                                    $t('revertValue')
                                                "
                                                tabindex="-1"
                                            >
                                                <i class="fa fa-undo-alt"></i>
                                            </button>
                                        </div>
                                    </InputBox>
                                </div>
                                <div class="button-box"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Role -->
                    <div class="prop-block">
                        <div class="prop name">{{ $t('role') }}</div>
                        <div class="prop">
                            <div class="input-box dropdown">
                                <DropdownMenu
                                    :options="displayedRoles"
                                    outline
                                    :disabled="!editOther"
                                    @change="setRole"
                                    :value="user.role"
                                >
                                    <div
                                        class="current-label"
                                        :class="{
                                            discrepancy:
                                                initialUser.role !== user.role,
                                        }"
                                    >
                                        {{ $t('currently') }}:
                                        {{ initialRoleLabel }}
                                        <button
                                            class="revert-icon"
                                            @click="
                                                user.role = initialUser.role
                                            "
                                            v-tooltip.right="$t('revertValue')"
                                            tabindex="-1"
                                        >
                                            <i class="fa fa-undo-alt"></i>
                                        </button>
                                    </div>
                                </DropdownMenu>
                            </div>
                        </div>
                    </div>

                    <!-- System admin 2FA toggle -->
                    <div class="prop-block" v-if="canManageOwnServerAdmin2fa">
                        <div class="prop name">{{ $t('enable2FA') }}</div>
                        <div class="prop">
                            <Checkbox
                                @change="setEnableTwoFactor($event)"
                                :checked="!!user.totp_enabled"
                            ></Checkbox>
                        </div>
                    </div>

                    <div class="prop-block" v-if="canManageOwnServerAdmin2fa">
                        <div class="prop name">
                            {{ $t('regenerateRecoveryCodes') }}
                        </div>
                        <div class="prop password">
                            <Button
                                small
                                outline
                                :disabled="
                                    regeneratingRecoveryCodes ||
                                    !canRegenerateRecoveryCodes
                                "
                                @click="regenerateRecoveryCodesForSelf"
                            >
                                {{
                                    regeneratingRecoveryCodes
                                        ? $t('regenerating')
                                        : $t('regenerate')
                                }}
                            </Button>
                        </div>
                    </div>

                    <!-- Reset 2FA (admin/org admin only) -->
                    <div class="prop-block" v-if="canResetUserTwoFactor">
                        <div class="prop name">{{ $t('reset2FA') }}</div>
                        <div class="prop password">
                            <Button
                                small
                                color="red"
                                outline
                                :disabled="resetTwoFaInProgress"
                                @click="resetUserTwoFactorForUser"
                            >
                                {{
                                    resetTwoFaInProgress
                                        ? $t('resetting')
                                        : $t('reset2FA')
                                }}
                            </Button>
                        </div>
                    </div>

                    <!-- Organization -->
                    <div
                        class="prop-block"
                        v-if="
                            !isUserAdmin ||
                            (isUserAdmin && user.role !== 'server_admin')
                        "
                    >
                        <div class="prop name">{{ $t('organization') }}</div>
                        <div class="prop">
                            <div class="input-box dropdown twofapadding">
                                <DropdownMenu
                                    :options="sortedOrganizations"
                                    outline
                                    max-height="200px"
                                    :disabled="
                                        !editOther ||
                                        (isUserAdmin &&
                                            user.id === currentUser.id) ||
                                        (isUserAdmin &&
                                            user.role === 'server_admin')
                                    "
                                    @change="setOrganization"
                                    :value="organizationId"
                                >
                                    <div
                                        class="current-label"
                                        :class="{
                                            discrepancy:
                                                initialOrganization?.id !==
                                                organization?.id,
                                        }"
                                    >
                                        {{ $t('currently') }}:
                                        {{ initialOrganizationLabel }}
                                        <button
                                            class="revert-icon"
                                            @click="
                                                organization =
                                                    initialOrganization
                                            "
                                            v-tooltip.right="$t('revertValue')"
                                            tabindex="-1"
                                        >
                                            <i class="fa fa-undo-alt"></i>
                                        </button>
                                    </div>
                                </DropdownMenu>
                                <div
                                    :class="{
                                        'not-allowed':
                                            !organization?.two_factor,
                                    }"
                                >
                                    <div class="twofaname">{{ $t('2fa') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Events header -->
                    <div class="prop-block event">
                        <div class="prop name">
                            {{ $t('eventNotificationMethods') }}
                        </div>
                    </div>

                    <!-- Email addresses header -->
                    <div class="prop-block event subhead borderline">
                        <div class="prop name event-header">
                            {{ $t('email') }}
                        </div>
                        <div class="prop right">
                            <Button
                                circle
                                small
                                @click="openEmailDialog"
                                outline
                                ><i class="fa fa-plus"></i
                            ></Button>
                        </div>
                    </div>

                    <!-- Email addresses -->
                    <div class="setlistgap">
                        <div
                            class="prop-block event"
                            v-for="(emailObj, index) in user.email_addresses"
                            :key="emailObj.id"
                        >
                            <div class="prop" />
                            <div class="prop with-delete">
                                <div class="input-box">
                                    <div class="input-wrapper">
                                        <div
                                            :class="{
                                                'has-error':
                                                    userEmailsValidity[
                                                        index
                                                    ] === false,
                                            }"
                                        >
                                            <InputBox
                                                center
                                                class="pad-right"
                                                hoverShow
                                                type="text"
                                                v-model="
                                                    user.email_addresses[index]
                                                "
                                                placeholder="user@example.com"
                                            >
                                                <div
                                                    class="current-label"
                                                    :class="{
                                                        discrepancy:
                                                            initialUserEmails[
                                                                index
                                                            ] !==
                                                            user
                                                                .email_addresses[
                                                                index
                                                            ],
                                                    }"
                                                >
                                                    {{ $t('currently') }}:
                                                    {{
                                                        initialUserEmails[index]
                                                    }}
                                                    <button
                                                        class="revert-icon"
                                                        @click="
                                                            handleRevertEmail(
                                                                index,
                                                                emailObj,
                                                            )
                                                        "
                                                        v-tooltip.right="
                                                            $t('revertValue')
                                                        "
                                                        tabindex="-1"
                                                    >
                                                        <i
                                                            class="fa fa-undo-alt"
                                                        ></i>
                                                    </button>
                                                </div>
                                            </InputBox>
                                        </div>
                                    </div>

                                    <div class="test-btn-ctn">
                                        <Button
                                            @click="testEmail(emailObj)"
                                            color="light-blue"
                                            outline
                                            small
                                            tab
                                            tabindex="-1"
                                        >
                                            {{ $t('test') }}
                                        </Button>
                                    </div>
                                    <div class="delete-btn-ctn">
                                        <button @click="deleteEmail(emailObj)">
                                            <i class="far fa-times-circle" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Phone numbers header -->
                        <div class="prop-block event subhead borderline">
                            <div class="prop name event-header">
                                {{ $t('phone') }}
                            </div>
                            <div class="prop right">
                                <Button
                                    circle
                                    small
                                    @click="openPhoneNumberDialog"
                                    outline
                                    ><i class="fa fa-plus"></i
                                ></Button>
                            </div>
                        </div>

                        <!-- Phone numbers -->
                        <v-touch
                            v-for="(phone, index) in user.phone_numbers"
                            :key="index"
                            v-touch:swipe.left="() => (phoneSwipeIndex = index)"
                            v-touch:swipe.right="() => swipePhoneRight(index)"
                            class="prop-block event"
                            :class="{ swiped: phoneSwipeIndex === index }"
                        >
                            <div class="prop" />
                            <div class="prop with-delete">
                                <div class="input-box">
                                    <div
                                        :class="{
                                            'has-error':
                                                phoneValidity[index] === false,
                                        }"
                                    >
                                        <InputBox
                                            center
                                            class="pad-right"
                                            hoverShow
                                            noSpinner
                                            type="text"
                                            inputmode="numeric"
                                            @keydown="onlyDigits"
                                            @paste.prevent
                                            v-model="user.phone_numbers[index]"
                                            placeholder="15556667777"
                                        >
                                            <div
                                                class="current-label"
                                                :class="{
                                                    discrepancy:
                                                        initialUserPhoneNumbers[
                                                            index
                                                        ] !==
                                                        user.phone_numbers[
                                                            index
                                                        ],
                                                }"
                                            >
                                                {{ $t('currently') }}:
                                                {{
                                                    initialUserPhoneNumbers[
                                                        index
                                                    ]
                                                }}
                                                <button
                                                    class="revert-icon"
                                                    @click="
                                                        handleRevertPhoneNumber(
                                                            index,
                                                            phone,
                                                        )
                                                    "
                                                    v-tooltip.right="
                                                        $t('revertValue')
                                                    "
                                                    tabindex="-1"
                                                >
                                                    <i
                                                        class="fa fa-undo-alt"
                                                    ></i>
                                                </button>
                                            </div>
                                        </InputBox>
                                    </div>
                                </div>
                                <div class="test-btn-ctn">
                                    <Button
                                        @click="testPhone(phone)"
                                        color="light-blue"
                                        outline
                                        small
                                        tab
                                        tabindex="-1"
                                    >
                                        {{ $t('test') }}
                                    </Button>
                                </div>
                                <div class="delete-btn-ctn">
                                    <button @click="deletePhone(phone)">
                                        <i class="far fa-times-circle"></i>
                                    </button>
                                </div>
                            </div>
                        </v-touch>
                    </div>

                    <!-- Event Notification Language -->
                    <div class="prop-block settopgap">
                        <div class="prop name">
                            {{ $t('eventNotificationLanguage') }}
                        </div>
                        <div class="prop">
                            <div class="input-box dropdown">
                                <DropdownMenu
                                    :options="languages"
                                    outline
                                    @change="setEventNotificationLanguage"
                                    :value="user.notify_lang"
                                >
                                    <div
                                        class="current-label"
                                        :class="{
                                            discrepancy:
                                                initialUser.notify_lang !==
                                                user.notify_lang,
                                        }"
                                    >
                                        {{ $t('currently') }}:
                                        {{ initialLanguageLabel }}
                                        <button
                                            class="revert-icon"
                                            @click="
                                                user.notify_lang =
                                                    initialUser.notify_lang
                                            "
                                            v-tooltip.right="$t('revertValue')"
                                            tabindex="-1"
                                        >
                                            <i class="fa fa-undo-alt"></i>
                                        </button>
                                    </div>
                                </DropdownMenu>
                            </div>
                        </div>
                    </div>

                    <!-- Allowed Event Notifications -->
                    <div class="prop-block event">
                        <div class="prop name">
                            {{ $t('allowedEventNotifications') }}
                        </div>
                    </div>

                    <!-- Allow email event notifications -->
                    <div class="prop-block event subhead">
                        <div class="prop name event-header">
                            {{ $t('email') }}
                        </div>
                        <div class="prop">
                            <Checkbox
                                @change="setAllowEmail($event)"
                                :checked="user.notify_email"
                            ></Checkbox>
                        </div>
                    </div>

                    <!-- Allow phone event notifications -->
                    <div class="prop-block event subhead">
                        <div class="prop name event-header">
                            {{ $t('phone') }}
                        </div>
                        <div class="prop">
                            <Checkbox
                                @change="setAllowSMS($event)"
                                :checked="user.notify_sms"
                            ></Checkbox>
                        </div>
                    </div>

                    <!-- Event filter toggle -->
                    <div class="prop-block top-margin">
                        <div class="prop name">
                            {{ $t('eventNotificationFilter') }}
                        </div>
                        <div class="prop toggle">
                            <Toggle
                                :leftValue="'alerts_only'"
                                :rightValue="'all'"
                                :value="eventNotificationLevel"
                                :leftLabel="$t('alertOnly')"
                                :rightLabel="$t('all')"
                                @change="filterToggle($event)"
                            >
                            </Toggle>
                        </div>
                    </div>

                    <!-- Open change password dialog -->
                    <div class="prop-block">
                        <div class="prop name">{{ $t('updatePassword') }}</div>
                        <div class="prop password">
                            <Button small @click="openPasswordDialog" outline>{{
                                $t('update')
                            }}</Button>
                        </div>
                    </div>

                    <!-- Add Email Address modal -->
                    <Modal
                        v-if="showAddEmailAddress"
                        @ok="addEmailAddress(newEmail)"
                        @cancel="showAddEmailAddress = false"
                        :confirmDisabled="!isValidEmailEntry"
                    >
                        <template #header>
                            <h3>{{ $t('addEmailAddress') }}</h3>
                        </template>
                        <template #body>
                            <div class="modal-body">
                                <div class="prop-block">
                                    <div class="prop name">
                                        {{ $t('email') }}
                                    </div>
                                    <div class="prop input">
                                        <div class="input-box">
                                            <div
                                                class="input-wrapper"
                                                :class="{
                                                    'has-error':
                                                        !isValidEmailEntry,
                                                }"
                                            >
                                                <InputBox
                                                    type="text"
                                                    center
                                                    v-model="newEmail"
                                                    placeholder="user@example.com"
                                                    ref="emailInput"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="prop-block center">
                                    <Button
                                        @click="testEmail(newEmail)"
                                        outline
                                        v-if="!testInProgress"
                                        >{{ $t('test') }}</Button
                                    >
                                    <div class="spinner-block" v-else>
                                        <div class="dots"></div>
                                        <div class="spinner-container">
                                            <div class="blocks">
                                                <div class="block one"></div>
                                                <div class="block two"></div>
                                                <div class="block three"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Modal>

                    <!-- Add phone number modal -->
                    <Modal
                        v-if="showAddPhoneNumber"
                        @ok="addPhoneNumber(newPhoneNumber)"
                        @cancel="showAddPhoneNumber = false"
                        :confirmDisabled="!isValidPrefixAndNumber"
                    >
                        <template #header>
                            <h3>{{ $t('addPhoneNumber') }}</h3>
                        </template>
                        <template #body>
                            <div class="modal-body">
                                <div class="prop-block">
                                    <div class="prop name">
                                        {{ $t('countryCode') }}
                                    </div>
                                    <div class="prop input">
                                        <div class="input-box country">
                                            <span class="country-plus">+</span>
                                            <div
                                                :class="{
                                                    'has-error':
                                                        !isValidPhonePrefixModal,
                                                }"
                                            >
                                                <InputBox
                                                    noSpinner
                                                    center
                                                    v-model="
                                                        newPhoneCountryCode
                                                    "
                                                    placeholder="1"
                                                    ref="phoneInput"
                                                    type="text"
                                                    inputmode="numeric"
                                                    @keydown="onlyDigits"
                                                    @paste.prevent
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="prop-block">
                                    <div class="prop name">
                                        {{ $t('phoneNumber') }}
                                    </div>
                                    <div class="prop input">
                                        <div class="input-box">
                                            <div
                                                :class="{
                                                    'has-error':
                                                        !isValidPhoneNumberLengthModal,
                                                }"
                                            >
                                                <InputBox
                                                    noSpinner
                                                    center
                                                    v-model="newPhoneNumber"
                                                    placeholder="5554441234"
                                                    type="text"
                                                    inputmode="numeric"
                                                    @keydown="onlyDigits"
                                                    @paste.prevent
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="prop-block center">
                                    <Button
                                        @click="
                                            testPhone(
                                                newPhoneCountryCode +
                                                    newPhoneNumber,
                                            )
                                        "
                                        outline
                                        v-if="!testInProgress"
                                    >
                                        {{ $t('test') }}
                                    </Button>
                                    <div class="spinner-block" v-else>
                                        <div class="dots"></div>
                                        <div class="spinner-container">
                                            <div class="blocks">
                                                <div class="block one"></div>
                                                <div class="block two"></div>
                                                <div class="block three"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Modal>

                    <!-- Change password modal -->
                    <Modal
                        v-if="showUpdatePassword"
                        @ok="changePassword"
                        @cancel="showUpdatePassword = false"
                    >
                        <template #header>
                            <h3>{{ $t('updatePassword') }}</h3>
                        </template>
                        <template #body>
                            <div>
                                <div class="prop-block">
                                    <div class="prop"></div>
                                    <div class="prop right">
                                        <div
                                            class="visible-button"
                                            :class="{
                                                visible: newPasswordVisible,
                                            }"
                                            @click="
                                                newPasswordVisible =
                                                    !newPasswordVisible
                                            "
                                        >
                                            <i
                                                class="fa"
                                                :class="{
                                                    'fa-eye':
                                                        newPasswordVisible,
                                                    'fa-eye-slash':
                                                        !newPasswordVisible,
                                                }"
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="prop-block">
                                    <div class="prop name">
                                        {{ $t('newPassword') }}
                                    </div>
                                    <div class="prop input">
                                        <div class="input-box">
                                            <InputBox
                                                :password="!newPasswordVisible"
                                                center
                                                v-model="newPassword"
                                                ref="newPasswordInput"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="prop-block">
                                    <div class="prop name">
                                        {{ $t('confirmPassword') }}
                                    </div>
                                    <div class="prop input">
                                        <div class="input-box">
                                            <InputBox
                                                :password="!newPasswordVisible"
                                                center
                                                v-model="confirmPassword"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="error-text"
                                    v-if="passwordCheckFailure"
                                >
                                    * {{ $t('passwordRequirements') }}
                                </div>
                                <div
                                    class="error-text"
                                    v-if="passwordMismatchError"
                                >
                                    * {{ $t('passwordMismatch') }}
                                </div>
                            </div>
                        </template>
                    </Modal>

                    <Modal
                        v-if="showRecoveryCodesModal"
                        noFooter
                        @cancel="showRecoveryCodesModal = false"
                    >
                        <template #header>
                            <h3>{{ $t('tstarRecoveryCodes') }}</h3>
                        </template>
                        <template #body>
                            <p>
                                {{ $t('saveRecoveryCodesSubtitle') }}
                            </p>
                            <div class="recovery-codes-grid">
                                <div
                                    class="recovery-code"
                                    v-for="code in recoveryCodes"
                                    :key="code"
                                >
                                    {{ code }}
                                </div>
                            </div>
                            <div class="prop-block center">
                                <Button @click="copyRecoveryCodes" outline>
                                    Copy Codes
                                </Button>
                                <Button @click="downloadRecoveryCodes" outline>
                                    Download .txt
                                </Button>
                                <Button @click="showRecoveryCodesModal = false">
                                    Close
                                </Button>
                            </div>
                        </template>
                    </Modal>
                </div>
                <span class="user-edit-loading" v-else>{{
                    $t('userLoading')
                }}</span>
            </template>
        </Card>
    </div>
</template>

<script>
import toastr from 'toastr';
import { mapGetters } from 'vuex';
import { toRaw } from 'vue';

import {
    getCurrentUser,
    getUser,
    resetUserTwoFactor,
    saveUser,
    saveMe,
    updatePassword,
    updateMyPassword,
    testSms,
    testEmail,
} from '../../api/user';
import { LANGUAGES, NotificationFlags } from '../../constants';
import { changeMonitor } from '../../api/ChangeMonitor';
import * as client from '../../api/client';
import { getOrganizationUser } from '../../api/organizations';
import {
    regenerateRecoveryCodes,
    validatePhoneNumber,
    validatePhoneNumberMultiPass,
} from '../../api/auth';

export default {
    name: 'UserEdit',

    data() {
        return {
            confirmPassword: '',
            initialUser: undefined,
            newPassword: '',
            newEmail: '',
            newPhoneCountryCode: '',
            newPhoneNumber: '',
            roles: [
                { label: this.$t('serverAdmin'), value: 'server_admin' },
                {
                    label: this.$t('campaignManager'),
                    value: 'campaign_manager',
                },
                {
                    label: this.$t('organizationAdmin'),
                    value: 'organization_admin',
                },
                { label: this.$t('normalUser'), value: 'standard' },
            ],
            organization: { id: '0' },
            initialOrganization: { id: '0' },
            showAddEmailAddress: false,
            showAddPhoneNumber: false,
            showUpdatePassword: false,
            newPasswordVisible: false,
            user: undefined,
            saveInProgress: false, // An api call to save the campaign is being made right now
            saveFailed: false, // The last call to save failed
            saveSucceeded: false, // The last call to save succeeded
            saveFailText: '', // Text to pass to the save widget in the event that a save fails,
            phoneSwipeIndex: -1, // The index of the phone row that may have been swiped
            emailSwipeIndex: -1, // The index of the email row swiped by the user
            testInProgress: false, // Whether or not the user is currently testing an eventnotification
            passwordCheckFailure: false, // True if the last check to update password failed
            passwordMismatchError: false, // True if the passwords in the password update modal do not match
            redirectBack: false,
            changedEmail: '',
            emailSnapshot: [],
            phoneValidity: [],
            phoneNumberSnapshot: [],
            isValidPhoneNumber: false,
            isValidPhoneNumberModal: false,
            initialUserEmails: [],
            initialUserPhoneNumbers: [],
            userEmailsValidity: [],
            myChildOrgs: [],
            resetTwoFaInProgress: false,
            regeneratingRecoveryCodes: false,
            showRecoveryCodesModal: false,
            recoveryCodes: [],
            suppressNextChangeNotification: false, // Suppress notification after we make an edit
            lastHandledChangeTimestamp: 0, // Track when we last handled a change to prevent duplicates
            lastHandledChangeKey: '', // Track what change we last handled to detect exact duplicates
        };
    },

    watch: {
        $route(to, from) {
            // If we've changed routes, we have a new user to display unless
            //  unless we're looking at the non admin view of the same user
            const adminMeViewToMeView =
                from.params.userId &&
                Number(from.params.userId) === this.currentUser.id &&
                to.path === '/me';
            const meViewToAdminMeView =
                from.path === '/me' &&
                to.params.userId &&
                Number(to.params.userId) === this.currentUser.id;
            if (
                to.path !== from.path &&
                !meViewToAdminMeView &&
                !adminMeViewToMeView
            ) {
                this.initialUser = undefined;
                this.user = undefined;

                if (!this.selfEditView) {
                    this.getUserInformation();
                } else {
                    this.initialUser = this.copyStoreUser();
                    this.user = this.copyStoreUser();
                    this.organization = this.copyStoreOrganization();
                }
            }
        },

        currentUser: {
            deep: true,
            handler(val, oldVal) {
                // If we're on the me page, the user data we're editing should be from store
                if (this.selfEditView) {
                    // Any changes in store should be compared against the changes currently being made
                    this.initialUser = this.copyStoreUser();
                    // If we don't have a user to edit, set it
                    if (
                        !this.user ||
                        this.user.id !== this.$store.state.currentUser.id
                    ) {
                        this.user = this.copyStoreUser();
                        this.organization = this.copyStoreOrganization();
                    }
                }
            },
        },

        user: {
            deep: true,
            async handler(val, oldVal) {
                // If we changed users, we haven't actually edited any values
                if (val && oldVal && val.id === oldVal.id) {
                    // Only mark as edited if email/name are valid AND they've actually changed from initialUser
                    // This prevents 2FA-only changes from triggering the edited flag
                    if (
                        val.email != null &&
                        val.email.trim() != '' &&
                        this.isValidEmail(val.email.trim()) &&
                        val.name != null &&
                        val.name.trim() != ''
                    ) {
                        this.edits = true;
                    } else {
                        this.edits = false;
                    }
                }
            },
        },

        // email_addresses watcher added to detect changes to the list, sets this.changedEmail
        // for validator for reflective condition to show color if email is valid from the
        // page element
        'user.email_addresses': {
            deep: true,
            handler(newList) {
                if (!Array.isArray(newList)) return;

                const oldList = this.emailSnapshot;

                if (newList.length > 0) {
                    const changedIndex = newList.findIndex(
                        (email, i) => email !== oldList[i],
                    );

                    if (changedIndex !== -1) {
                        this.userEmailsValidity[changedIndex] =
                            this.isValidUserAddressesEmailEntry(changedIndex);

                        if (
                            !this.isValidEmail(
                                this.user.email_addresses[changedIndex],
                            )
                        ) {
                            this.edits = false;
                        }
                    }

                    this.emailSnapshot = [...newList];
                }
            },
        },

        // watch for newPhoneNumber changes and validate on changes
        newPhoneNumber: {
            deep: true,
            handler(newNumber) {
                this.isValidPhoneNumber = this.checkPhoneNumber(newNumber);
            },
        },

        // phone_numbers watcher added to detect changes to the list, sets this.phoneValidity[index]
        // for validator for reflective condition to show color if phoneNumber is valid from the
        // page element
        'user.phone_numbers': {
            deep: true,
            async handler(newList) {
                if (!Array.isArray(newList)) return;

                const oldList = this.phoneNumberSnapshot;

                if (newList.length > 0) {
                    const changedIndex = newList.findIndex(
                        (number, i) => number !== oldList[i],
                    );

                    if (changedIndex !== -1) {
                        this.phoneValidity[changedIndex] =
                            await validatePhoneNumberMultiPass(
                                newList[changedIndex],
                            );
                        if (!this.phoneValidity[changedIndex]) {
                            this.edits = false;
                        }
                    }

                    this.phoneNumberSnapshot = [...newList];
                }
            },
        },

        redirectBack(newVal) {
            if (newVal) {
                if (this.$route.redirectedFrom) {
                    // If Vue Router knows where we came from
                    this.$router.push(this.$route.redirectedFrom.fullPath);
                } else if (window.history.state.back) {
                    // Try browser history
                    this.$router.back();
                } else {
                    // Fallback route if no "caller"
                    this.$router.push('/dashboard');
                }
            }
        },
    },

    computed: {
        ...mapGetters(['isUserAdmin', 'isOrganizationAdmin']),

        currentUser() {
            return this.$store.state.currentUser;
        },

        // Used by the save widget and for knowing whether or not the user has unsaved changes when navigating
        edits: {
            get() {
                return this.$store.state.editsOnPage;
            },

            set(value) {
                this.$store.commit('setEditsOnPage', value);
            },
        },

        organizations() {
            return this.$store.state.organizations;
        },

        organizationId() {
            if (typeof this.organization !== 'undefined') {
                return parseInt(this.organization.id);
            }
            return 0;
        },

        initialRoleLabel() {
            if (this.initialUser) {
                for (const role of this.roles) {
                    if (this.initialUser.role === role.value) {
                        return role.label;
                    }
                }
                return this.initialUser.role;
            }
            return '';
        },

        initialOrganizationLabel() {
            if (this.initialOrganization) {
                return this.initialOrganization.organization_name;
            }
            return '';
        },

        languages() {
            return LANGUAGES;
        },

        initialLanguageLabel() {
            if (this.initialUser) {
                for (const language of this.languages) {
                    if (this.initialUser.notify_lang === language.value) {
                        return language.label;
                    }
                }
                return this.initialUser.eventNotificationLanguage;
            }
            return '';
        },

        emails() {
            if (this.user && this.user.email_addresses) {
                return this.user.email_addresses;
            } else {
                return [];
            }
        },

        selfEditView() {
            return this.$route.path === '/me';
        },

        eventNotificationLevel() {
            if (this.user && this.user.notification_level) {
                return this.user.notification_level;
            } else {
                return '';
            }
        },

        // sorts the organizations alphabetically by label for the organizations dropdown menu display
        sortedOrganizations() {
            if (this.organizationOptions.length > 0) {
                return this.organizationOptions.slice().sort((a, b) => {
                    return a.label.localeCompare(b.label);
                });
            }
            return [];
        },

        saveState() {
            if (this.saveInProgress) {
                return 'sending';
            } else if (this.saveFailed) {
                return 'retry';
            } else if (this.saveSucceeded && !this.edits) {
                return 'success';
            } else if (this.edits) {
                return 'changes';
            }

            return 'hidden';
        },

        displayedRoles() {
            if (this.isUserAdmin) {
                return this.roles;
            }
            return this.roles.slice(1);
        },

        editOther() {
            return this.user.email != this.currentUser.email;
        },

        organizationOptions() {
            return this.$store.state.organizations.map((org) => ({
                label: org.organization_name,
                value: Number(org.id),
            }));
        },

        isValidUserEmailEntry() {
            const hasEmail = this.isValidEmail(this.user.email);

            return Boolean(hasEmail);
        },

        isValidUserAddress() {
            return (index) => {
                return this.isValidEmail(this.user.email_addresses[index]);
            };
        },

        isValidEmailEntry() {
            const hasEmail = this.isValidEmail(this.newEmail);
            return Boolean(hasEmail);
        },

        isValidPhonePrefixModal() {
            return Boolean(
                this.newPhoneCountryCode.length > 0 &&
                    this.newPhoneCountryCode.length <= 3,
            );
        },

        isValidPhoneNumberLengthModal() {
            return this.isValidPhoneNumberModal;
        },

        isValidPrefixAndNumber() {
            return (
                this.isValidPhonePrefixModal &&
                this.isValidPhoneNumberLengthModal
            );
        },

        canResetUserTwoFactor() {
            if (!this.user) {
                return false;
            }

            if (this.user.role === 'server_admin') {
                return false;
            }

            return this.isUserAdmin || this.isOrganizationAdmin;
        },

        canManageOwnServerAdmin2fa() {
            return (
                !!this.user &&
                !!this.currentUser &&
                this.isUserAdmin &&
                this.user.role === 'server_admin' &&
                Number(this.user.id) === Number(this.currentUser.id)
            );
        },

        canRegenerateRecoveryCodes() {
            if (!this.canManageOwnServerAdmin2fa) {
                return false;
            }

            // The server never sends the secret itself, only whether one is set.
            return this.user?.totp_secret_configured === true;
        },
    },

    async created() {
        // Fetch fresh user data from server for all views to ensure up-to-date state
        // (especially important after 2FA setup when totp_secret is persisted).
        if (!this.selfEditView) {
            await this.getUserInformation();
        } else {
            const response = await getCurrentUser();
            if (response.status === client.STATUS_OK && response.payload) {
                this.user = response.payload;
                this.initialUser = structuredClone(toRaw(this.user));
                let emails = [];
                if (this.user.email_addresses) {
                    emails = Array.isArray(this.user.email_addresses)
                        ? [...this.user.email_addresses]
                        : [];
                }
                let numbers = [];
                if (this.user.phone_numbers) {
                    numbers = Array.isArray(this.user.phone_numbers)
                        ? [...this.user.phone_numbers]
                        : [];
                }
                this.initialUser.email_addresses = emails;
                this.initialUser.phone_numbers = numbers;
                this.initialUserEmails = emails;
                this.initialUserPhoneNumbers = numbers;
            } else {
                this.initialUser = this.copyStoreUser();
                this.user = this.copyStoreUser();
                this.initialUserEmails = [...this.user.email_addresses];
                this.initialUserPhoneNumbers = [...this.user.phone_numbers];
            }
            this.organization = this.copyStoreOrganization();
            await this.getOrganizationInformation();
        }

        // Register for change notifications based on which view we're in
        // Reset the deduplication tracking when registering fresh listeners
        this.lastHandledChangeTimestamp = 0;
        this.lastHandledChangeKey = '';

        if (this.selfEditView) {
            // Viewing own profile - register as notified user
            changeMonitor.addNotifiedUser(this.handleChanges);
        } else {
            // Viewing another user's profile - register as viewer user
            changeMonitor.addViewerUser(this.handleChanges);
        }
    },

    mounted() {
        this.phoneValidity = Array.isArray(this.user?.phone_numbers)
            ? this.user.phone_numbers.map(() => null)
            : [];
        this.userEmailsValidity = Array.isArray(this.user?.email_addresses)
            ? this.user.email_addresses.map(() => null)
            : [];
    },

    beforeUnmount() {
        // Remove the appropriate listener based on which view we were in
        if (this.selfEditView) {
            changeMonitor.removeNotifiedUser(this.handleChanges);
        } else {
            changeMonitor.removeViewerUser(this.handleChanges);
        }
    },

    methods: {
        async getChildOrgs(parentsId) {
            for (const organization of this.$store.state.organizations) {
                if (organization.parent_organization_id === parentsId) {
                    this.myChildOrgs.push({
                        id: organization.id,
                        organization_name: organization.organization_name,
                        parent_organization_id:
                            organization.parent_organization_id,
                        two_factor: organization.two_factor,
                    });
                    await getChildOrgs(organization.id);
                }
            }
        },

        // only allow digets for entry
        onlyDigits(event) {
            const allowedControlKeys = [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'Tab',
                'Home',
                'End',
            ];

            // Allow control/navigation keys
            if (allowedControlKeys.includes(event.key)) return;

            // Block anything not 0–9
            if (!/^[0-9]$/.test(event.key)) {
                event.preventDefault();
            }
        },

        // check if phone number is valid via server api call
        async checkPhoneNumber() {
            this.isValidPhoneNumberModal = await validatePhoneNumber(
                this.newPhoneCountryCode,
                this.newPhoneNumber,
            );
        },

        // check if email at index is valid
        isValidUserAddressesEmailEntry(index) {
            return this.isValidEmail(this.user.email_addresses[index]);
        },

        // add new email address to user object
        addEmailAddress(newEmail) {
            this.showAddEmailAddress = false;

            if (this.user.email_addresses == null) {
                this.user.email_addresses = [];
            }

            if (newEmail !== '') {
                this.user.email_addresses.push(newEmail);
            }
        },

        // add new phone number to user object
        addPhoneNumber(newPhoneNumber) {
            this.showAddPhoneNumber = false;

            if (this.user.phone_numbers == null) {
                this.user.phone_numbers = [];
            }

            if (this.newPhoneNumber && this.newPhoneCountryCode) {
                this.user.phone_numbers.push(
                    this.newPhoneCountryCode + this.newPhoneNumber,
                );
            }
        },

        handleRevertEmail(index, emailObj) {
            const original = this.initialUserEmails[index];

            if (original && original.trim() !== '') {
                this.user.email_addresses[index] = original;
            } else {
                this.deleteEmail(emailObj);
            }
        },

        handleRevertPhoneNumber(index, phone) {
            const original = this.initialUserPhoneNumbers[index];

            if (original && original.trim() !== '') {
                this.user.phone_numbers[index] = original;
            } else {
                this.deletePhone(phone);
            }
        },

        // cancel user edit
        cancelUserSettings() {
            this.user = {
                ...this.initialUser,
            };
            this.user.email_addresses = [...this.initialUserEmails];
            this.user.phone_numbers = [...this.initialUserPhoneNumbers];
            this.phoneValidity = Array.isArray(this.user?.phone_numbers)
                ? this.user.phone_numbers.map(() => null)
                : [];
            this.userEmailsValidity = Array.isArray(this.user?.email_addresses)
                ? this.user.email_addresses.map(() => null)
                : [];

            this.organization = { ...this.initialOrganization };
            this.enableOrganization(this.user.role);

            setTimeout(() => {
                this.edits = false;
            });
        },

        async changePassword() {
            if (
                this.newPassword === this.confirmPassword &&
                this.newPassword.length >= 8
            ) {
                this.passwordMismatchError = false;
                // Check to see if we need to use the non admin endpoint
                let errorResponse = null;
                let response;
                if (this.selfEditView) {
                    response = await updateMyPassword({
                        password: this.newPassword,
                    });
                } else {
                    response = await updatePassword(this.user.id, {
                        password: this.newPassword,
                    });
                }

                if (response.status === client.STATUS_ERROR) {
                    errorResponse = response;
                    this.passwordCheckFailure = true;
                }

                if (errorResponse) {
                    // Call failed, print custom message if applicable
                    if (errorResponse.msg) {
                        toastr.error(
                            this.$t(errorResponse.msg, errorResponse.msg_data),
                        );
                    } else {
                        toastr.error(this.$t('passwordUpdateFailed'));
                    }
                } else {
                    // Call succeeded, cleanup
                    this.newPassword = '';
                    this.confirmPassword = '';
                    this.showUpdatePassword = false;
                    toastr.success(this.$t('passwordUpdateSuccess'));
                }
            } else {
                this.passwordMismatchError = true;
            }
        },

        normalizeNotificationLanguage(language) {
            if (typeof language !== 'string') {
                return language;
            }

            const trimmedLanguage = language.trim();
            if (!trimmedLanguage) {
                return trimmedLanguage;
            }

            const supportedLanguages = Array.isArray(this.languages)
                ? this.languages
                : LANGUAGES;
            const exactMatch = supportedLanguages.find(
                (entry) =>
                    typeof entry?.value === 'string' &&
                    entry.value.toLowerCase() === trimmedLanguage.toLowerCase(),
            );

            if (exactMatch) {
                return exactMatch.value;
            }

            const baseLanguage = trimmedLanguage.split('-')[0];
            const baseMatch = supportedLanguages.find(
                (entry) =>
                    typeof entry?.value === 'string' &&
                    entry.value.toLowerCase() === baseLanguage.toLowerCase(),
            );

            if (baseMatch) {
                return baseMatch.value;
            }

            return trimmedLanguage;
        },

        copyStoreUser() {
            if (this.$store.state.currentUser) {
                let emails = [];
                if (this.$store.state.currentUser.email_addresses) {
                    emails = structuredClone(
                        toRaw(this.$store.state.currentUser.email_addresses),
                    );
                }
                let numbers = [];
                if (this.$store.state.currentUser.phone_numbers) {
                    numbers = structuredClone(
                        toRaw(this.$store.state.currentUser.phone_numbers),
                    );
                }
                return {
                    ...this.$store.state.currentUser,
                    notify_lang: this.normalizeNotificationLanguage(
                        this.$store.state.currentUser.notify_lang,
                    ),
                    email_addresses: emails,
                    phone_numbers: numbers,
                };
            }

            return undefined;
        },

        copyStoreOrganization() {
            if (this.$store.state.organization) {
                return {
                    ...this.$store.state.organization,
                };
            }

            return undefined;
        },

        // remove email
        deleteEmail(email) {
            this.user.email_addresses.splice(
                this.user.email_addresses.indexOf(email),
                1,
            );
        },

        // remove phone
        deletePhone(phone) {
            this.user.phone_numbers.splice(
                this.user.phone_numbers.indexOf(phone),
                1,
            );
        },

        // Test sending a notification to the user through email
        testEmail: async function (email) {
            // start the processing animations
            this.testInProgress = true;
            const response = await testEmail(
                email,
                this.normalizeNotificationLanguage(this.user.notify_lang),
            );

            if (response.status === NotificationFlags.Delivered) {
                toastr.success(this.$t('emailTestSuccessful'));
            } else if (response.status === NotificationFlags.Failed) {
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('emailTestFail'));
                }
            }
            // stop the processing animations
            this.testInProgress = false;
        },

        // Test sending a notification over SMS to a specific phone number
        testPhone: async function (phone) {
            this.testInProgress = true;

            const normalizedLanguage = this.normalizeNotificationLanguage(
                this.user.notify_lang,
            );

            const response = await testSms(phone, normalizedLanguage);

            if (response.status === NotificationFlags.Delivered) {
                toastr.success(this.$t('smsTestSuccessful'));
            } else if (response.status === NotificationFlags.Failed) {
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('smsTestFail'));
                }
            } else {
                toastr.error(this.$t('smsTestFail'));
            }
            // stop the processing animations
            this.testInProgress = false;
        },

        // Change the selected value for the user's notification filter level
        filterToggle(value) {
            if (this.user) {
                this.user.notification_level = value;
            }
        },

        async getOrganizationInformation() {
            // get the user organization
            const organizationResponse = await getOrganizationUser(
                this.user.id,
            );
            if (organizationResponse.payload != null) {
                if (organizationResponse.status === client.STATUS_OK) {
                    this.organization = this.organizations.find(
                        (o) =>
                            o.id ===
                            organizationResponse.payload.organization_id.toString(),
                    );
                    this.initialOrganization = { ...this.organization };
                } else {
                    if (organizationResponse.msg) {
                        toastr.error(
                            this.$t(
                                organizationResponse.msg,
                                organizationResponse.msg_data,
                            ),
                        );
                    } else {
                        toastr.error(this.$t('problemLoadingOrganizationUser'));
                    }
                }
            } else {
                this.organization = { id: 0 };
                this.initialOrganization = { id: 0 };
            }
        },

        // Should only be called on the admin view of the page, non admins use the info from Vuex store
        async getUserInformation() {
            const response = await getUser(this.$route.params.userId);
            if (response.status === 'ERROR') {
                this.redirectBack = true;
            } else {
                if (response.status === client.STATUS_OK) {
                    this.user = response.payload;
                    this.user.notify_lang = this.normalizeNotificationLanguage(
                        this.user.notify_lang,
                    );
                    let emails = [];
                    if (this.user.email_addresses) {
                        emails = Array.isArray(this.user.email_addresses)
                            ? [...this.user.email_addresses]
                            : [];
                    }
                    let numbers = [];
                    if (this.user.phone_numbers) {
                        numbers = Array.isArray(this.user.phone_numbers)
                            ? [...this.user.phone_numbers]
                            : [];
                    }
                    this.initialUser = structuredClone(toRaw(this.user));
                    this.initialUser.email_addresses = emails;
                    this.initialUser.phone_numbers = numbers;

                    this.initialUserEmails = Array.isArray(
                        this.user.email_addresses,
                    )
                        ? [...this.user.email_addresses]
                        : [];

                    this.initialUserPhoneNumbers = Array.isArray(
                        this.user.phone_numbers,
                    )
                        ? [...this.user.phone_numbers]
                        : [];
                } else {
                    if (response.msg) {
                        toastr.error(this.$t(response.msg, response.msg_data));
                    } else {
                        toastr.error(this.$t('problemLoadingUser'));
                    }
                }

                // ensure organization is up to date in the store object
                await this.getOrganizationInformation();
            }
        },

        handleChanges(change) {
            if (change.changeType === 'USER') {
                // We only care if it's the user whose page we're on
                if (change.data.id === this.user.id) {
                    // Prevent duplicate notifications within 1000ms (listener called multiple times)
                    // Use a simple key based on user ID and key changed fields
                    const now = Date.now();
                    const changeKey = `${change.data.id}-${change.data.totp_enabled}-${change.data.totp_secret_configured}`;

                    if (
                        this.lastHandledChangeKey === changeKey &&
                        now - this.lastHandledChangeTimestamp < 1000
                    ) {
                        return; // Skip exact duplicate
                    }

                    this.lastHandledChangeTimestamp = now;
                    this.lastHandledChangeKey = changeKey;

                    // The underlying data to compare against should match the new changes
                    const email_addresses = change.data.email_addresses
                        ? [...change.data.email_addresses]
                        : [];
                    const phone_numbers = change.data.phone_numbers
                        ? [...change.data.phone_numbers]
                        : [];
                    this.initialUser = structuredClone(toRaw(this.user));
                    this.initialUser.email_addresses = email_addresses;
                    this.initialUser.phone_numbers = phone_numbers;

                    // Show notification only if:
                    // 1. We didn't just make this edit (flag is false), AND
                    // 2. We're viewing our own profile (selfEditView is true)
                    // Don't show if admin is viewing another user's profile (they know they made the change)
                    if (
                        !this.suppressNextChangeNotification &&
                        this.selfEditView
                    ) {
                        toastr.info(this.$t('externalChanges'));
                    }
                    this.suppressNextChangeNotification = false; // Reset flag for next time

                    // Update the displayed data
                    this.user = {
                        ...change.data,
                        notify_lang: this.normalizeNotificationLanguage(
                            change.data.notify_lang,
                        ),
                        email_addresses,
                        phone_numbers,
                    };
                    // Normally, updating user triggers edits on page, prevent that
                    setTimeout(() => {
                        this.edits = false;
                    });
                }
            }
        },

        // open change password dialog
        openPasswordDialog() {
            this.showUpdatePassword = true;
            this.passwordCheckFailure = false;
            this.passwordMismatchError = false;
            this.newPassword = '';
            this.confirmPassword = '';
            this.$nextTick(() => this.$refs.newPasswordInput.setFocus());
        },

        // open add email dialog
        openEmailDialog() {
            this.showAddEmailAddress = true;
            this.newEmail = '';
            this.$nextTick(() => this.$refs.emailInput.setFocus());
        },

        // open add phone number dialog
        openPhoneNumberDialog() {
            this.showAddPhoneNumber = true;
            this.newPhoneNumber = '';
            this.newPhoneCountryCode = '';
            this.$nextTick(() => this.$refs.phoneInput.setFocus());
        },

        setAllowEmail(event) {
            const value = event.target?.checked ?? !!event;
            this.user.notify_email = value;
        },

        setAllowSMS(event) {
            const value = event.target?.checked ?? !!event;
            this.user.notify_sms = value;
        },

        setEnableTwoFactor(event) {
            const value = event.target?.checked ?? !!event;
            this.user.totp_enabled = value;
        },

        async regenerateRecoveryCodesForSelf() {
            if (!this.canRegenerateRecoveryCodes) {
                return;
            }

            const confirmed = window.confirm(
                this.$t('regenerateRecoveryCodesConfirmation'),
            );
            if (!confirmed) {
                return;
            }

            this.regeneratingRecoveryCodes = true;
            // Set flag BEFORE API call so it's already true when notification arrives
            this.suppressNextChangeNotification = true;
            try {
                const response = await regenerateRecoveryCodes();
                const codes = response?.payload?.recovery_codes;

                if (
                    response.status === client.STATUS_OK &&
                    Array.isArray(codes) &&
                    codes.length > 0
                ) {
                    this.recoveryCodes = codes;
                    this.showRecoveryCodesModal = true;
                    toastr.success(this.$t('recoveryCodesRegenerated'));
                    return;
                }

                // On error, reset the flag
                this.suppressNextChangeNotification = false;
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('unableToRegenerateRecoveryCodes'));
                }
            } finally {
                this.regeneratingRecoveryCodes = false;
            }
        },

        async copyRecoveryCodes() {
            const payload = this.recoveryCodes.join('\n');
            try {
                await navigator.clipboard.writeText(payload);
                toastr.success(this.$t('recoveryCodesCopied'));
            } catch {
                toastr.error(this.$t('unableToCopyRecoveryCodes'));
            }
        },

        downloadRecoveryCodes() {
            const lines = [
                this.$t('tstarRecoveryCodes'),
                this.$t('generated', { date: new Date().toISOString() }),
                '',
                ...this.recoveryCodes,
            ];
            const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'tstar-recovery-codes.txt';
            link.click();
            URL.revokeObjectURL(url);
            toastr.success(this.$t('recoveryCodeFileDownloaded'));
        },

        setEventNotificationLanguage(value) {
            this.user.notify_lang = this.normalizeNotificationLanguage(value);
        },

        // update role on user object
        setRole(value) {
            this.user.role = value;
            this.enableOrganization(value);
        },

        // update organization on user object
        async setOrganization(value) {
            this.organization = this.organizations.find(
                (o) => parseInt(o.id) === value,
            );
            this.edits = true;
        },

        enableOrganization(role) {
            if (role === 'server_admin') {
                this.organization = { id: 0 };
            } else {
                // only set the org option to first org option value if there is no organization data
                if (!this.organization.id) {
                    this.organization = this.organizations.find(
                        (o) =>
                            parseInt(o.id) ===
                            this.organizationOptions[0].value,
                    );
                    this.initialOrganization = { ...this.organization };
                }
            }
        },

        // save user
        async saveUserSettings() {
            this.edits = false;
            this.saveInProgress = true;
            // Set flag BEFORE API calls so it's already true when notification arrives
            this.suppressNextChangeNotification = true;
            let response = null;
            let errorResponse = null;
            let updateUser = {
                ...this.user,
                notify_lang: this.normalizeNotificationLanguage(
                    this.user.notify_lang,
                ),
                organization_id: this.organization.id,
            };
            if (this.selfEditView) {
                response = await saveMe(updateUser);
                if (response.status === client.STATUS_ERROR) {
                    errorResponse = response;
                }
            } else {
                response = await saveUser(
                    this.user.id,
                    this.organization.id,
                    updateUser,
                );

                if (response.status === client.STATUS_ERROR) {
                    errorResponse = response;
                }
            }

            if (errorResponse) {
                // On error, reset the flag
                this.suppressNextChangeNotification = false;
                if (response.msg) {
                    this.saveFailText = this.$t(
                        response.msg,
                        response.msg_data,
                    );
                }
                this.saveFailed = true;
                this.saveSucceeded = false;
            } else {
                this.saveFailed = false;
                this.saveSucceeded = true;
                this.saveFailText = '';
                this.initialOrganization = {
                    id: this.organization.id,
                    organization_name: this.organization.organization_name,
                    parent_organization_name:
                        this.organization.parent_organization_name,
                    two_factor: this.organization.two_factor,
                };
                this.initialUser = JSON.parse(JSON.stringify(this.user));
                this.initialUserEmails = JSON.parse(
                    JSON.stringify(this.user.email_addresses),
                );
                this.initialUserPhoneNumbers = JSON.parse(
                    JSON.stringify(this.user.phone_numbers),
                );

                this.enableOrganization(this.user.role);
            }
            this.saveInProgress = false;

            this.$root.$emit('pageSaveComplete');
        },

        async resetUserTwoFactorForUser() {
            if (!this.canResetUserTwoFactor || !this.user?.id) {
                return;
            }

            if (this.user.role === 'server_admin') {
                return;
            }

            const confirmed = window.confirm(
                this.$t('resetUser2FAConfirmation'),
            );
            if (!confirmed) {
                return;
            }

            this.resetTwoFaInProgress = true;
            // Set flag BEFORE API call so it's already true when notification arrives
            this.suppressNextChangeNotification = true;
            try {
                const response = await resetUserTwoFactor(this.user.id);

                if (response.status === client.STATUS_OK) {
                    // Update UI with returned state from server
                    this.user.totp_enabled =
                        response.payload?.totp_enabled ?? false;
                    this.user.totp_secret_configured =
                        response.payload?.totp_secret_configured ?? false;

                    if (this.initialUser) {
                        this.initialUser.totp_enabled = this.user.totp_enabled;
                        this.initialUser.totp_secret_configured =
                            this.user.totp_secret_configured;
                    }

                    // If org requires 2FA, only secret was cleared
                    if (this.user.totp_enabled) {
                        toastr.success(this.$t('user2FASecretReset'));
                    } else {
                        // Full reset
                        toastr.success(this.$t('user2FAHasBeenReset'));
                    }
                    return;
                }

                // On error, reset the flag
                this.suppressNextChangeNotification = false;
                if (response.msg) {
                    toastr.error(this.$t(response.msg, response.msg_data));
                } else {
                    toastr.error(this.$t('unableToReset2FA'));
                }
            } finally {
                this.resetTwoFaInProgress = false;
            }
        },

        swipePhoneRight(index) {
            if (index === phoneSwipeIndex) {
                phoneSwipeIndex = -1;
            }
        },

        swipeEmailRight(index) {
            if (index === emailSwipeIndex) {
                emailSwipeIndex = -1;
            }
        },

        isValidEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },
    },
};
</script>
